import React, { useEffect, useState } from 'react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 13,
    seconds: 11
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) {
            clearInterval(timer);
            return {
              minutes: 0,
              seconds: 0
            };
          }
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          minutes: prev.minutes,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 w-full bg-[#BE185D] text-white z-50 py-2 px-3 text-center shadow-md" data-id="element-45">
      <p className="font-bold text-xs md:text-sm tracking-wide flex items-center justify-center gap-1.5 flex-wrap" data-id="element-46">
        <span data-id="element-47">
          ⏳ OFERTA EXPIRA EN:{' '}
          <span className="font-mono text-base bg-black/20 px-1.5 py-0.5 rounded" data-id="element-48">
            {formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)}
          </span>
        </span>
        <span className="hidden md:inline" data-id="element-49">|</span>
        <span className="block md:inline" data-id="element-50">🔥 CUPOS LIMITADOS</span>
      </p>
    </div>;
}